import { Grid } from "@material-ui/core";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
} from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import React, { useState } from "react";
import { addItemById, deleteItemById } from ".";
import { TableJasa } from "../../Paket/ui/TabJasa";
import { TableItemTransfer } from "pages/Penjualan/Master/Rikjang/tabs/TabBarang";
import { ITEM_TYPE_JASA } from "pages/Penjualan/Master/Rikjang/constants";
import { ModalForm, RESET_TAB_MODAL } from "./ModalForm";

function TabJasa({ formData, setFormData, templateID }) {
  const [formJasa, setFormJasa] = useState(RESET_TAB_MODAL);
  const [showModal, setShowModal] = useState(false);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleClickSelect = async (row) => {
    setFormJasa({
      id: "",
      item_type: ITEM_TYPE_JASA,
      item_id: row.id,
      name: row.nama,
      qty: 1,
    });
    setShowModal(!showModal);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      const jasa = formData.jasa;
      const checkJasa = jasa.filter((e) => e.item_id === formJasa.item_id);
      if (checkJasa.length === 0) {
        if (!isNull(templateID)) {
          const res = await addItemById({
            id_template: templateID,
            item_type: ITEM_TYPE_JASA,
            item_id: formJasa.item_id,
            qty: formJasa.qty,
          });
          if (res.state) {
            defaultToastSuccess(res.message);
            jasa.push({
              id: res.data.id,
              id_template: templateID,
              item_type: ITEM_TYPE_JASA,
              item_id: formJasa.item_id,
              nama_jasa: formJasa.name,
              qty: formJasa.qty,
            });
            setFormData({
              ...formData,
              jasa,
            });
          } else {
            defaultToastError(res.message);
          }
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        } else {
          jasa.push({
            item_type: ITEM_TYPE_JASA,
            item_id: formJasa.item_id,
            nama_jasa: formJasa.name,
            qty: formJasa.qty,
          });

          setFormData({
            ...formData,
            jasa,
          });
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        }
      } else {
        defaultToastError("Jasa sudah ada");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
      }
    } catch (error) {}
  };

  const clickDelete = async (row) => {
    const jasa = formData.jasa;
    const checkJasa = jasa.filter((e) => e.item_id !== row.item_id);
    setFormData({
      ...formData,
      jasa: checkJasa,
    });

    if (!isNull(templateID)) {
      const res = await deleteItemById(row.id);
      if (res.state) {
        defaultToastSuccess(res.message);
      } else {
        defaultToastError(res.message);
      }
    }
  };

  return (
    <div>
      {showModal && (
        <ModalForm
          setShowModal={() => setShowModal(false)}
          form={formJasa}
          setForm={setFormJasa}
          disabled={disabled}
          handleSubmit={handleSubmit}
        />
      )}
      <Grid container spacing={2}>
        <Grid item sm={6}>
          <TableJasa handleClickSelect={handleClickSelect} />
        </Grid>

        <Grid item sm={6}>
          <TableItemTransfer
            rows={formData.jasa}
            clickDelete={clickDelete}
            filter='nama_jasa'
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default TabJasa;
